import { render, staticRenderFns } from "./3.vue?vue&type=template&id=5cdccd8d&scoped=true&"
var script = {}
import style0 from "./3.vue?vue&type=style&index=0&id=5cdccd8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdccd8d",
  null
  
)

export default component.exports